import {
    LEARN_MORE_TEXT,
    signalInfoTextMap,
} from "app/pages/sales-intelligence/modules/company-analysis/services/signals/maps/newsSignalTextMap";
import type {
    NewsSignalEventDto,
    SignalEventDto,
} from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import PartialText from "app/pages/sales-intelligence/pages/company-analysis/components/shared/PartialText/PartialText";

import SignalCompanyLink from "./SignalCompanyLink";
import { StyledSignalText, StyledSignalPartialText } from "./styles";

type NewsSignalEventInfoProps = {
    signal: NewsSignalEventDto;
    onCompanyLinkClick: (signalEvent: SignalEventDto) => void;
    onShowDescriptionClick: () => void;
};

const NewsSignalEventInfo = ({ signal, onCompanyLinkClick, onShowDescriptionClick }: NewsSignalEventInfoProps) => {
    const { relatedCompanyDomain = "", categories } = signal;

    const subtype = categories[0];

    const signalInfoTextMapValue = signalInfoTextMap[subtype];

    const text = typeof signalInfoTextMapValue === "function" ? signalInfoTextMapValue(signal) : signalInfoTextMapValue;

    const handleOnCompanyLinkClick = () => onCompanyLinkClick(signal);

    if (!text) {
        return null;
    }

    return (
        <StyledSignalText data-automation="signal-event-info-news-text">
            {text === LEARN_MORE_TEXT ? (
                <>
                    <span>{`${text} `}</span>
                    <SignalCompanyLink
                        domain={relatedCompanyDomain}
                        onCompanyLinkClick={handleOnCompanyLinkClick}
                        data-automation="signal-event-info-news-company-link"
                    >
                        {relatedCompanyDomain}
                    </SignalCompanyLink>
                </>
            ) : (
                <StyledSignalPartialText>
                    <PartialText
                        height={18}
                        text={text}
                        onShowMoreClick={onShowDescriptionClick}
                    />
                </StyledSignalPartialText>
            )}
        </StyledSignalText>
    );
};

export default NewsSignalEventInfo;
